export default __webpack_public_path__ + "static/media/folderHoverIcon.be8677cf.svg";